// extracted by mini-css-extract-plugin
module.exports = {"copyBtn":"motion-toolbar_copyBtn__P0iW_"};